/* Niva V9 — sepette ücretsiz kargo çubuğu. Güven şeridi sunucu tarafında (niva-purchase-info). */
(function () {
  var ESIK = 950;

  function kargoCubugu() {
    if (location.pathname.indexOf('/cart') === -1) return;
    if (document.querySelector('.niva-ship-bar')) return;
    var form = document.getElementById('niva-cart-form');
    if (!form || form.dataset.shippingProgress !== 'true') return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) return;
        var toplam = cart.total_price / 100;
        var kalan = Math.max(0, ESIK - toplam);
        var oran = Math.min(100, (toplam / ESIK) * 100);
        var bar = document.createElement('div');
        bar.className = 'niva-ship-bar';
        var metin = document.createElement('p');
        metin.textContent = kalan > 0
          ? 'Ücretsiz kargoya ' + kalan.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL kaldı.'
          : 'Standart kargo bu siparişte ücretsiz.';
        var iz = document.createElement('span');
        iz.className = 'niva-ship-track';
        var dolu = document.createElement('i');
        dolu.style.width = oran + '%';
        iz.appendChild(dolu);
        bar.appendChild(metin);
        bar.appendChild(iz);
        var hedef = document.querySelector('main .wrap') || document.querySelector('main');
        if (hedef) hedef.insertBefore(bar, hedef.firstChild);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kargoCubugu);
  else kargoCubugu();
  document.addEventListener('shopify:section:load', kargoCubugu);
})();